import { DateTime } from "luxon";

export function url(strings: TemplateStringsArray, ...variables: any[]): string {
    let u = '';

    for (let i = 0; i < variables.length; i++)
        u += strings[i] + encodeURIComponent(variables[i]);

    u += strings[strings.length - 1];

    return u;
}

/**
 * Generates a `URLSearchParams` instance from an object
 *  
 */
export function buildQueryParams(params: Record<string, string | DateTime | number | null | undefined | boolean>): URLSearchParams {
    const queryParams = new URLSearchParams();

    for(let [key, val] of Object.entries(params)) {
        if(val === null || val === undefined) {
            continue;
        } else if(val instanceof DateTime) {
            val = val.toISODate();
        } else if(typeof val === 'number' || typeof val === 'boolean') {
            val = val.toString();
        }

        queryParams.append(key, val);
    }

    return queryParams;
}